import { TPatchRole, TPostRole, TQueryRole } from '@src/modules'

import { request } from './config'

export const postRole = (data: TPostRole) => request({ url: 'role', method: 'POST', data })
export const getListRole = (params: TQueryRole, token: string) =>
  request({ url: 'role', method: 'GET', params }, { token })
export const getListPermission = (token: string) => request({ url: 'role/permissions', method: 'GET' }, { token })
export const getRoleCurrent = (token: string) => request({ url: 'role/current', method: 'GET' }, { token })
export const getRoleById = (id: number, token: string) => request({ url: `role/${id}`, method: 'GET' }, { token })
export const patchRoleById = (id: number, data: TPatchRole) => request({ url: `role/${id}`, method: 'PATCH', data })
export const removeRoleById = (id: number) => request({ url: `role/${id}`, method: 'DELETE' })
